import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { MARKING_EDITOR_WEB_COMPONENT_ELEMENT, KEY_DELETE, KEY_BACKSPACE } from '@/constants';
import { usePopupOpen } from '@/hooks';
import { checkCtrlPressed, isActiveElementEditable } from '@/helpers';
import { handleFreeSpaceClick, deleteSectionThunk, deleteSelectedSectionsContentThunk } from '@/actions';

export default props => {
  const { isDeleteAvailable } = props;
  const dispatch = useDispatch();
  const isSomePopupOpen = usePopupOpen();

  useEffect(() => {
    if (isSomePopupOpen) {
      handleRemoveListenters();
    } else {
      document.addEventListener('mousedown', handleMouseDown);
      document.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      handleRemoveListenters();
    };
  });

  const handleRemoveListenters = () => {
    document.removeEventListener('mousedown', handleMouseDown);
    document.removeEventListener('keydown', handleKeyDown);
  };

  const handleMouseDown = event => {
    if (event.target.nodeName !== MARKING_EDITOR_WEB_COMPONENT_ELEMENT.toUpperCase()) {
      dispatch(handleFreeSpaceClick());
    }
  };

  const handleKeyDown = event => {
    if (!isActiveElementEditable()) {
      const isCtrlPressed = checkCtrlPressed(event);
      const isDeleteButtonPressed = event.code === KEY_DELETE;
      const isBackspaceButtonPressed = event.code === KEY_BACKSPACE;

      if ((isDeleteButtonPressed || isBackspaceButtonPressed) && isDeleteAvailable) {
        if (isCtrlPressed) {
          dispatch(deleteSectionThunk());
        } else {
          dispatch(deleteSelectedSectionsContentThunk());
        }
        return;
      }
    }
  };
};
